import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest
} from "./api.request";

const EXPENSE_REPORT_PATH = "/apis/expense-report/v1/expense-report";
const EXPENSE_EXPORT_PATH = "/apis/expense-report/v1/export";

// Main expense report API
export const getExpenseReportApi = async (params) =>
  await getRequest(EXPENSE_REPORT_PATH, params);

export const exportExpenseReportApi = async (params) =>
  await getRequest(EXPENSE_EXPORT_PATH, params);
